var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnPrivacyProtection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-privacy-protection",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(9.236 5.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(0 13.653)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(13.539 51.341)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(4.832)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(0 27.552)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(30.922)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(18.824 63.153)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(27.398 31.535)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18994",
    "data-name": "Group 18994",
    transform: "translate(22.034 19.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18995",
    "data-name": "Group 18995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25505",
    "data-name": "Path 25505",
    d: "M107.592,117.151a18.149,18.149,0,0,1-8.582,15.274,3.8,3.8,0,0,1-4.221-.011,17.716,17.716,0,0,1-7.8-10.314,17.516,17.516,0,0,1-.768-5.965,1.033,1.033,0,0,1,.983-1.043,9.727,9.727,0,0,0,6.435-3.106,8.2,8.2,0,0,1,2.006-1.588,2.487,2.487,0,0,1,2.524,0,8.59,8.59,0,0,1,2.061,1.644,9.645,9.645,0,0,0,5.454,2.932c.315.053.634.082.952.117a1.031,1.031,0,0,1,.95,1.021c.01.346,0,.692,0,1.038M96.885,131.009a4.51,4.51,0,0,0,.884-.293,14.879,14.879,0,0,0,4.364-3.893.413.413,0,0,0,.07-.283,3.384,3.384,0,0,0-2.784-2.779.626.626,0,0,0-.522.138,3.125,3.125,0,0,1-3.974,0,.64.64,0,0,0-.548-.134,3.372,3.372,0,0,0-2.759,2.773.476.476,0,0,0,.09.325,14.72,14.72,0,0,0,4.244,3.8,5.4,5.4,0,0,0,.935.347m-2.947-12.424a4.852,4.852,0,0,0,1.55,3.37,2.007,2.007,0,0,0,2.892-.046,4.783,4.783,0,0,0,1.345-2.268,3.371,3.371,0,0,0,.125-1.487,2.982,2.982,0,0,0-5.912.431",
    transform: "translate(-78.88 -100.701)",
    fill: "#2fa2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25506",
    "data-name": "Path 25506",
    d: "M119.444,11.822V11.5q0-1.778,0-3.556A7.878,7.878,0,1,1,135.2,7.95c-.006,1.185,0,2.37,0,3.556,0,.092,0,.185,0,.36-.454-.223-.868-.395-1.249-.621a10.08,10.08,0,0,1-1.076-.765.479.479,0,0,1-.129-.335c-.012-.778,0-1.557-.008-2.336a5.417,5.417,0,0,0-10.764-.79,5.534,5.534,0,0,0-.064.8c-.009.666-.032,1.334.005,2a.94.94,0,0,1-.444.928,8.051,8.051,0,0,1-2.025,1.079",
    transform: "translate(-109.293 0)",
    fill: "#2fa2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25507",
    "data-name": "Path 25507",
    d: "M27.614,58.61c2.671.87,5.251,1.7,7.813,2.572a1.078,1.078,0,0,1,.563.748A31.921,31.921,0,0,1,20.343,93.98a3.733,3.733,0,0,1-4.462-.007C4.869,87.1-.466,77.255.032,64.275c.037-.973-.109-2.175.4-2.845.472-.627,1.692-.7,2.59-1,1.827-.6,3.658-1.2,5.568-1.819a20.923,20.923,0,0,1-.2,2.363c-.047.249-.428.523-.714.625-1.415.5-2.842.978-4.281,1.4a.962.962,0,0,0-.806,1.026q-.843,18.338,14.878,27.8a1.466,1.466,0,0,0,1.216.046c9.806-5.1,16.109-16.922,14.908-27.95a1.269,1.269,0,0,0-.691-.861c-1.406-.526-2.839-.982-4.277-1.415-.573-.173-.885-.407-.853-1.072a15.555,15.555,0,0,0-.155-1.973",
    transform: "translate(0 -53.629)",
    fill: "#007dba"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPrivacyProtection);
export default __webpack_public_path__ + "static/media/icn-privacy-protection.2ca03cca1bd4d6d09d7df369839b3d03.svg";
export { ForwardRef as ReactComponent };